import React, {createContext, useContext, useEffect} from 'react'
import {useBranding, applyBrandingToDOM} from '../hooks/useBranding'

const BrandingContext = createContext()

export const useBrandingContext = () => {
  const context = useContext(BrandingContext)
  if (!context) {
    throw new Error('useBrandingContext must be used within a BrandingProvider')
  }
  return context
}

export const BrandingProvider = ({children}) => {
  const {branding, loading, updateBranding} = useBranding()

  // Apply branding to DOM when it changes
  useEffect(() => {
    if (branding) {
      applyBrandingToDOM(branding)
    }
  }, [branding])

  // Load Google Fonts dynamically
  useEffect(() => {
    if (branding && (branding.heading_font || branding.body_font)) {
      const fonts = new Set([branding.heading_font, branding.body_font].filter(Boolean))
      
      // Remove existing Google Fonts link
      const existingLink = document.querySelector('#google-fonts')
      if (existingLink) {
        existingLink.remove()
      }

      // Add new Google Fonts link
      if (fonts.size > 0) {
        const link = document.createElement('link')
        link.id = 'google-fonts'
        link.rel = 'stylesheet'
        link.href = `https://fonts.googleapis.com/css2?${Array.from(fonts)
          .map(font => `family=${font.replace(/\s+/g, '+')}`)
          .join('&')}&display=swap`
        document.head.appendChild(link)
      }
    }
  }, [branding])

  return (
    <BrandingContext.Provider value={{branding, loading, updateBranding}}>
      {children}
    </BrandingContext.Provider>
  )
}